/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	'use strict'
	/**
	 * Timeline
	 * @author Nikola Lakovic
	 * @namespace Tc.Module.Timeline.js
	 * @class Timeline
	 * @extends Tc.Module
	 *
	 **/

	Tc.Module.Timeline = Tc.Module.extend({

		on: function(callback) {

			var mod = this,
				$ctx = this.$ctx,
				$panelContainer = $ctx.find('.pannel_container'),
				$panel = $ctx.find('.container'),
				$nav = $ctx.find('nav'),
				totalPanels = $panel.length;
				mod.height = $ctx.data('height');
				mod.width = $ctx.data('width');
				mod.top = $ctx.data('top');
				mod.left = $ctx.data('left');

			mod.setTimelineDimensions($ctx, $panel, $panelContainer);
			mod.setTimelinePosition();

			if (totalPanels < 2) {
				$nav.remove();
				callback();
				return false;
			}

			mod.adjustLayout();

			callback();
		},

		adjustLayout: function() {
			var mod = this,
				$ctx = mod.$ctx;

			var $panel = $ctx.find('.container'),
				$nav = $ctx.find('nav'),
				panelWidth = $panel.width(),
				totalPanels = $panel.length,
				leftPos = parseInt(panelWidth / (totalPanels - 1));

			$panel.each(function(index) {
				var newX = panelWidth * index,
					$this = $(this);

				$this.css({
					'left': newX + 'px'
				});

				var newLabel = $this.find('.modImageMapContainer').data('year');
				$nav.append('<a href="#" style="left:' + leftPos * index + 'px"><span>' + newLabel + '</span></a>');
			});

			$nav.find('a:first-child').addClass('selected');
			var currentPanel = $nav.find('a:last-child').index();

			mod.activateNavigation();
		},

		activateNavigation: function() {
			var mod = this,
				$ctx = mod.$ctx,
				$nav = $ctx.find('nav'),
				$link = $nav.find('a'),
				panelWidth = $ctx.width(),
				$panelSlider = $ctx.find('.panel_slider'),
				$activePanel = $ctx.find('.container');

			if ($ctx.data('slide') !== true) {
				$activePanel.css('left', 0).hide().first().show();
			}

			$link.on('click', function(event) {
				event.preventDefault();
				/* Act on the event */
				var $this = $(this),
					currentPanel = $this.index();

				$link.removeClass('selected');
				$this.addClass('selected');

				if ($ctx.data('slide')) {

					var newPosition = ((currentPanel * panelWidth) * -1);

					$panelSlider.animate({
						left: newPosition + 'px'
					}, 700);

				} else {

					$activePanel.eq($this.index()).fadeIn(500).siblings().fadeOut(500);
				}

			});
		},

		setTimelineDimensions: function() {
			var mod = this,
				$ctx = mod.$ctx;

			for (var i = 0; i < arguments.length; i++) {
				arguments[i].css({
					width: mod.width + 'px',
					height: mod.height + 'px'
				});
			}
		},

		setTimelinePosition: function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.css({
				top: mod.top,
				left: mod.left
			});
		}

	});
})(Tc.$);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.Timeline.js
// module id = 195
// module chunks = 0